// Blog slide: latest posts from the blog API, with tag filter, search and
// "Older posts". Loads the first time the slide is opened.
import { api, esc, formatDate, postUrl } from "../blog/api";

const PAGE_SIZE = 5;
const SEARCH_DELAY_MS = 300;

export default function initBlog() {
  const list = document.getElementById("blog-list");
  if (!list) return;
  const slide = list.closest(".slide");
  const tagBar = document.getElementById("blog-tags");
  const search = document.getElementById("blog-search");
  const status = document.getElementById("blog-status");
  const more = document.getElementById("blog-more");

  let started = false;
  let page = 1;
  let tag = "";
  let query = "";
  let request = 0; // ignore answers to outdated requests
  let searchTimer;

  function setStatus(text, { retry = false } = {}) {
    status.textContent = text;
    status.hidden = !text;
    if (retry) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "blog__retry";
      btn.textContent = "Try again";
      btn.addEventListener("click", () => {
        load();
        loadTags();
      });
      status.append(" ", btn);
    }
  }

  function card(p) {
    const tags = p.tags.map((t) => `<span>#${esc(t)}</span>`).join("");
    return `<li>
      <a class="post-card" href="${postUrl(p.slug)}">
        <span class="post-card__meta">${esc(formatDate(p.published_at))} · ${p.reading_minutes} min read</span>
        <span class="post-card__main">
          <span class="post-card__title">${esc(p.title)}</span>
          ${p.summary ? `<span class="post-card__summary">${esc(p.summary)}</span>` : ""}
          ${tags ? `<span class="post-card__tags">${tags}</span>` : ""}
          <span class="post-card__more">Read more <i class="fa fa-arrow-right" aria-hidden="true"></i></span>
        </span>
      </a>
    </li>`;
  }

  async function load({ append = false } = {}) {
    const id = ++request;
    const params = new URLSearchParams({ page, limit: PAGE_SIZE });
    if (tag) params.set("tag", tag);
    if (query) params.set("q", query);
    if (!append) setStatus("Loading posts…");
    more.disabled = true;
    try {
      const data = await api(`/api/posts?${params}`);
      if (id !== request) return;
      const html = data.posts.map(card).join("");
      if (append) list.insertAdjacentHTML("beforeend", html);
      else list.innerHTML = html;
      more.hidden = data.page >= data.total_pages;
      if (data.total === 0) {
        setStatus(tag || query ? "No posts match that yet." : "First posts are on their way.");
      } else {
        setStatus("");
      }
    } catch {
      if (id !== request) return;
      if (!append) list.innerHTML = "";
      more.hidden = true;
      setStatus("Couldn't load the posts.", { retry: true });
    } finally {
      more.disabled = false;
    }
  }

  async function loadTags() {
    try {
      const { tags } = await api("/api/tags");
      if (!tags.length) return;
      tagBar.innerHTML = [`<button type="button" class="chip is-active" data-tag="">All</button>`]
        .concat(tags.slice(0, 12).map((t) => `<button type="button" class="chip" data-tag="${esc(t.name)}">#${esc(t.name)}</button>`))
        .join("");
      tagBar.hidden = false;
    } catch {
      /* the list shows the error */
    }
  }

  tagBar.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-tag]");
    if (!btn) return;
    tag = btn.dataset.tag;
    tagBar.querySelectorAll(".chip").forEach((c) => c.classList.toggle("is-active", c === btn));
    page = 1;
    load();
  });

  search.addEventListener("input", () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      query = search.value.trim();
      page = 1;
      load();
    }, SEARCH_DELAY_MS);
  });
  // Arrow keys move the caret in the search box, not the slides
  search.addEventListener("keydown", (e) => e.stopPropagation());

  more.addEventListener("click", () => {
    page += 1;
    load({ append: true });
  });

  function start() {
    if (started || !slide.classList.contains("is-active")) return;
    started = true;
    load();
    loadTags();
  }
  document.addEventListener("slidechange", start);
}
